<mat-form-field
  [appearance]="appearance"
  [class]="class"
  [dir]="direction"
  [floatLabel]="floatLabelType"
  >
  @if (label) {
    <mat-label [class]="'text-sm ' + labelClass">{{
      label
    }}</mat-label>
  }
  <!--
    a11y: property binding [aria-describedby] (not [attr.]) so MatSelect's @Input fires and
    the merged describedBy ids include our error id when the field is invalid+touched.
  -->
  <!--
    a11y: [attr.aria-label] gives the mat-select combobox an accessible name
    when no [label] / <mat-label> is set (e.g. tariff-profile selector). Bound
    via [attr.] so a falsy ariaLabel removes the attribute entirely and lets
    Material's auto-generated aria-labelledby (from <mat-label>) take over.
  -->
  <!--
    a11y: mat-select exposes role=combobox on the trigger. panelClass id + openedChange
    handler (component TS) moves DOM focus to the first list option on open and pauses dialog focus traps.
  -->
  <mat-select
    #matSelect
    [id]="comboboxPanelId"
    [formControl]="formControl"
    [compareWith]="compareWith"
    [class]="selectClass"
    [panelClass]="panelClass"
    [ngStyle]="{ 'text-align': direction === 'rtl' ? 'right' : 'left' }"
    [dir]="direction"
    [attr.aria-label]="comboboxAriaLabel"
    [attr.aria-controls]="comboboxControlsId"
    [attr.aria-expanded]="isPanelOpen ? 'true' : 'false'"
    aria-haspopup="listbox"
    [aria-describedby]="(formControl.invalid && formControl.touched && displayErrors) ? errorId : null"
    [attr.aria-invalid]="(formControl.invalid && formControl.touched) ? 'true' : null"
    >
    @if (!!hasTrigger) {
      <mat-select-trigger>
        <ng-content select="[trigger]" />
      </mat-select-trigger>
    }

    @for (opt of resolvedOptions; track trackOption($index, opt); let i = $index) {
      <mat-option
        [value]="opt.value"
        [disabled]="opt.disabled"
        >
        @if (customOptionTemplate) {
          <ng-container
            *ngTemplateOutlet="customOptionTemplate; context: { $implicit: opt }"
          ></ng-container>
        } @else {
          {{ opt.label }}
        }
      </mat-option>
    }
  </mat-select>
</mat-form-field>

@if (formControl.invalid && formControl.touched && !!displayErrors) {
  <mat-error
    [id]="errorId"
    class="error"
    role="alert"
    aria-live="assertive"
    [ngStyle]="{ 'text-align': direction === 'rtl' ? 'right' : 'left' }"
    style="color: red;"
    >
    {{ getFirstError() }}
  </mat-error>
}
